import { CommonModule, NgFor } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { CategoryService } from '../../../../Services/Category/category.service';
import { SubCategoriesService } from '../../../../Services/Category/sub-categories.service';
import { NotificationService } from '../../../../Services/notification.service';
import { FirmSelectionService } from '../../../../Services/firm-selection.service';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-sub-category',
  imports: [ReactiveFormsModule, NgFor, CommonModule],
  templateUrl: './sub-category.component.html',
  styleUrl: './sub-category.component.css'
})
export class SubCategoryComponent implements OnInit {
  subCategoryForm!: FormGroup;
  prodCategory: any;
  prodSubCategory: any;
  firmId !: number | null;
  currentPage = 1;
  itemsPerPage = 10;
  isEditMode: boolean = false;
  editingSubCategoryId: number | null = null;

  constructor(
    private fb: FormBuilder,
    private categoryService: CategoryService,
    private subCategoryService: SubCategoriesService,
    private notificationService: NotificationService,
    private firmSelectionService: FirmSelectionService
  ) { }

  ngOnInit(): void {
    const firm = this.firmSelectionService.getselectedFirmName();
    this.firmId = firm ? firm.id : null;

    this.initSubCategoryForm();
    this.getCategories();
    this.getSubCategories();

    this.listenCategoryChange();
  }

  initSubCategoryForm() {
    const firm = this.firmSelectionService.getselectedFirmName();

    this.subCategoryForm = this.fb.group({
      category_id: [''],
      name: [''],
      category_unit:[''],
      firm_id: [firm ? firm.id : null],
    })
  }

  getCategories() {
    let params = new HttpParams().append('sub_type','piece');

    this.categoryService.getCategories(params).subscribe((res: any) => {
      this.prodCategory = res.data
        .filter((cat: any) => cat.Type === "Master")
        .map((cat: any) => ({
          id: cat.id,
          name: cat.name,
          unit: cat.unit,
        }));

      // 🔥 Trigger unit patch if category already selected
      const categoryId = this.subCategoryForm.get('category_id')?.value;
      if (categoryId) {
        const selectedCategory = this.prodCategory.find(
          (cat: any) => String(cat.id) === String(categoryId)
        );
        if (selectedCategory) {
          this.subCategoryForm.patchValue({
            category_unit: selectedCategory.unit
          });
        }
      }
    });
  }

  onCategoryChange(event: Event) {
    const selectedCategoryId = (event.target as HTMLSelectElement).value;

    const selectedCategory = this.prodCategory.find(
      (cat: any) => String(cat.id) === String(selectedCategoryId)
    );

    if (selectedCategory) {
      this.subCategoryForm.patchValue({
        category_unit: selectedCategory.unit
      });
    } else {
      this.subCategoryForm.patchValue({
        category_unit: ''
      });
    }
  }

  listenCategoryChange() {
    this.subCategoryForm.get('category_id')?.valueChanges.subscribe(categoryId => {
      if (!categoryId) {
        this.subCategoryForm.patchValue({ category_unit: '' });
        return;
      }

      const selectedCategory = this.prodCategory?.find(
        (cat: any) => String(cat.id) === String(categoryId)
      );

      if (selectedCategory) {
        this.subCategoryForm.patchValue({
          category_unit: selectedCategory.unit
        });
      }
    });
  }


  addSubCategory() {
    const firm = this.firmSelectionService.getselectedFirmName();
    const firmId = firm ? firm.id : null;

    this.subCategoryForm.patchValue({
      firm_id: firmId
    });

    // ✅ UPDATE MODE
    if (this.isEditMode && this.editingSubCategoryId) {
      this.subCategoryService
        .updateSubCategory(this.editingSubCategoryId, this.subCategoryForm.value)
        .subscribe({
          next: () => {
            this.notificationService.showSuccess(
              'Subcategory updated successfully',
              'Success'
            );
            this.getSubCategories();
            this.clearForm();
          },
          error: () => {
            this.notificationService.showError(
              'Failed to update subcategory',
              'Error'
            );
          }
        });

    } else {
      // ✅ CREATE MODE
      console.log("form data",this.subCategoryForm.value);
      
      this.subCategoryService
        .createSubCategory(this.subCategoryForm.value)
        .subscribe({
          next: () => {
            this.notificationService.showSuccess(
              'Subcategory added successfully',
              'Success'
            );
            this.getSubCategories();
            this.clearForm();
          },
          error: () => {
            this.notificationService.showError(
              'Failed to add subcategory',
              'Error'
            );
          }
        });
    }
  }

  editSubCategory(subCategory: any) {
    this.isEditMode = true;
    this.editingSubCategoryId = subCategory.id;

    this.subCategoryForm.patchValue({
      category_id: subCategory.category_id,
      name: subCategory.name,
      firm_id: subCategory.firm_id
    });

    // UX: scroll to form
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }


  clearForm() {
  const firm = this.firmSelectionService.getselectedFirmName();

  // ✅ Exit edit mode
  this.isEditMode = false;
  this.editingSubCategoryId = null;

  // ✅ Reset form fields
  this.subCategoryForm.reset({
    category_id: '',
    name: '',
    firm_id: firm ? firm.id : null
  });
}


  getSubCategories() {
    this.subCategoryService.getSubCategories().subscribe((res: any) => {
      this.prodSubCategory = res.data;
    })
  }

  deleteSubCategory(id: any) {
    const isDeleted = confirm("Do you really want to delete this subcategory?");

    if (isDeleted) {
      this.subCategoryService.deleteSubCategory(id).subscribe({
        next: (res: any) => {
          this.getSubCategories();
          this.notificationService.showSuccess("Subcategory deleted successfully", "Success");
        },
        error: () => {
          this.notificationService.showError("Something went wrong", "Error");
        }
      });
    } else {
      this.notificationService.showWarning("Subcategory not deleted", "Warning");
    }
  }

  get paginatedSubCategories() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    return this.prodSubCategory?.slice(start, end) || [];
  }

  get totalPages() {
    return Math.ceil((this.prodSubCategory?.length || 0) / this.itemsPerPage);
  }
}
